import { emptyContentValidator } from '@/utils/sharefunc'

export const YOUTUBE_URL_REGEX = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
export const DRIVE_URL_REGEX = /^https:\/\//
export const DATE_FORMAT = 'YYYY/MM/DD HH:mm'

/* 表單欄位預設驗證規則 */
export const RULES = {
  required: { required: true, message: '欄位未填！', trigger: 'blur' },
  emptyContent: { validator: emptyContentValidator, trigger: 'blur' }
}

/* API 錯誤訊息 */
export const errorMsg = {
  'Can not find user.': '查無此信箱！',
  'Repeated user': '評分者重複！',
  'You can only add your own students': '查無此信箱！'
}

export const USER = {
  // 使用者身份 1:助教 2:學生
  role: {
    assistant: 1,
    student: 2
  },
  // 使用者來自 1:SAT. Knowledge 2:台大
  account_type: {
    sat: 1,
    ntu: 2
  }
}

export const GOPHER = {
  // 地鼠影片類型 1:專心 2:不專心
  type: {
    focused: 1,
    unfocused: 2
  }
}
